import React, { useCallback, useEffect, useMemo, useState } from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import { Link } from 'react-router-dom';
import TableContainer from 'Common/TableContainer';
import Select from 'react-select';
import { Loader } from '../../../Common/Loader'
import { format } from 'date-fns';// Icons
import { Pencil, Search, Trash2, Plus, } from 'lucide-react';
import Modal from 'Common/Components/Modal';
import DeleteModal from 'Common/DeleteModal';

import {
    getBannerList as onGetBannerList,
    deleteBannerList as onDeleteBannerList,
} from '../../../helpers/backend_helper';
import { ToastContainer } from 'react-toastify';
import { Common } from 'helpers/common';
import AddBanner from './AddBanner';
import { getImageUrl } from 'constants/constants';

const BannerList = () => {
    const [bannerList, setBannerList] = useState([]);
    const [bannerData, setBannerData] = useState<any>();
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [show, setShow] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const uiHelper = new Common();

    useEffect(() => {
        loadBanners(false);
    }, [])

    async function loadBanners(relead: boolean) {
        try {
            if (bannerList.length === 0 || relead) {

                let response = await onGetBannerList();
                if (response.success) {
                    console.log('obj', response.data);
                    setBannerList(response.data as never[]);
                }
            }
        } catch (error) {

        } finally {
            setIsLoading(false);
        }

    }

    // Delete Modal
    const deleteToggle = () => setDeleteModal(!deleteModal);

    // Delete Data
    const onClickDelete = (cell: any) => {
        setDeleteModal(true);
        if (cell.id) {
            setBannerData(cell);
        }
    };

    const handleDelete = async () => {
        if (bannerData) {
            await onDeleteBannerList(bannerData.id);
            setDeleteModal(false);
            uiHelper.showSuccessMessage('Banner has been deleted successfully.')
            // remove the item and then update list
            setBannerList(bannerList => bannerList.filter((cat: any, idx) => cat.id !== bannerData.id));
        }
    };
    // 

    // Update Data
    const handleEditDataClick = (ele: any) => {
        setBannerData({ ...ele });
        setIsEdit(true);
        setShow(true);
    };


    const handleAddBanner = () => {
        setBannerData({});
        toggle();
    }

    const onSave = (result: any) => {
        if (isEdit) {
            setBannerList(prevCat =>
                prevCat.map((cat: any, idx) =>
                    cat.id === bannerData.id ? { ...result } as never : { ...cat } as never
                )
            );
            setIsEdit(false);
        } else {
            setBannerList((prevCat) => [{ ...result } as never, ...prevCat],)
        }
        toggle();
    }

    const toggle = useCallback(() => {
        setShow(!show);
        if (show) {
            setBannerData(null);
        }

    }, [show]);


    // columns
    const Status = ({ item }: any) => {
        switch (item) {
            case true:
                return (<span className="status px-2.5 py-0.5 inline-block text-xs font-medium rounded border bg-green-100 border-transparent text-green-500 dark:bg-green-500/20 dark:border-transparent">Active</span>);
            case false:
                return (<span className="status px-2.5 py-0.5 inline-block text-xs font-medium rounded border bg-orange-100 border-transparent text-orange-500 dark:bg-orange-500/20 dark:border-transparent">InActive</span>);
        }
    };
    const columns = useMemo(() => [
        {
            header: "Title",
            accessorKey: "title",
            enableColumnFilter: true,
            enableSorting: true,
        },
        {
            header: "Logo",
            accessorKey: "logo",
            enableColumnFilter: false,
            cell: (cell: any) => (
                <div>
                    <div className="flex items-center justify-center size-10 font-medium rounded-full shrink-0 bg-slate-200 text-slate-800 dark:text-zink-50 dark:bg-zink-600">
                        {cell.row.original.logo ? <img src={ getImageUrl(cell.row.original.logo, 'bannerThumbnail') } alt="" className="h-10 rounded-full" /> : (cell.getValue().split(' ').map((word: any) => word.charAt(0)).join(''))}
                    </div>
                </div>
            ),
        },
        {
            header: "Start Date",
            accessorKey: "startDate",
            enableColumnFilter: false,
            enableSorting: false,
            cell: (cell: any) => (
                <p>{format(cell.getValue(), 'dd/MM/yyyy')}</p>
            ),
        },
        {
            header: "End Date",
            accessorKey: "endDate",
            enableColumnFilter: false,
            enableSorting: false,
            cell: (cell: any) => (
                <p>{format(cell.getValue(), 'dd/MM/yyyy')}</p>
            ),
        },

        {
            header: "Status",
            accessorKey: "isActive",
            enableColumnFilter: false,
            enableSorting: false,
            cell: (cell: any) => (
                <Status item={cell.getValue()} />
            ),
        },
        {
            header: "Action",
            enableColumnFilter: false,
            enableSorting: false,
            cell: (cell: any) => (

                <div className="flex justify-start gap-2" >
                    <Link data-modal-target="addUserModal" to="#!"
                        className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md text-slate-500 bg-slate-100 hover:text-white hover:bg-slate-500 dark:text-zink-200 dark:bg-zink-600 dark:hover:text-white dark:hover:bg-zink-400"
                        onClick={() => {
                            const data = cell.row.original;
                            handleEditDataClick(data);
                        }}>
                        <Pencil className="inline-block size-4 ltr:mr-1 rtl:ml-1" /> </Link>


                    <Link to="#!"
                        className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md text-red-500 bg-red-100 hover:text-white hover:bg-red-500 dark:bg-red-500/20 dark:hover:bg-red-500"
                        onClick={() => {
                            const orderData = cell.row.original;
                            onClickDelete(orderData);
                        }}><Trash2 className="inline-block size-4 ltr:mr-1 rtl:ml-1" /> </Link>
                </div>
            ),
        }
    ], []
    );

    const options = [
        { value: 'Select Status', label: 'Select Status' },
        { value: true, label: 'Active' },
        { value: false, label: 'inActive' },
    ];

    const handleChange = (selectedOption: any) => {
        if (selectedOption.value === 'Select Status' || selectedOption.value === 'Hidden') {
            setBannerList(bannerList);
        } else {
            const filteredUsers = bannerList.filter((data: any) => data.isActive === selectedOption.value);
            setBannerList(filteredUsers);
        }
    };

    return (
        <React.Fragment>
            <DeleteModal show={deleteModal} onHide={deleteToggle} onDelete={handleDelete} />
            <ToastContainer closeButton={false} limit={1} />

            <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12" style={{ marginTop: 15 }}>
                <div className="xl:col-span-12">
                    <div className="card" id="attributeTable">
                        <div className="flex items-center  border-y border-dashed" style={{ padding: 10 }}>
                            <h6 className="text-15 grow">Banners</h6>
                            <div className="shrink-0">
                                <button type="button" className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20" onClick={handleAddBanner}><Plus className="inline-block size-4" /> <span className="align-middle">Add Banner</span></button>
                            </div>
                        </div>

                       
                        {isLoading ? (<Loader />) :
                            (<div >
                                {bannerList && bannerList?.length > 0 ?
                                    <TableContainer
                                        isPagination={true}
                                        columns={(columns || [])}
                                        data={(bannerList || [])}
                                        customPageSize={10}
                                        divclassName="overflow-x-auto"
                                        tableclassName="w-full whitespace-nowrap"
                                        theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
                                        thclassName="px-3.5 py-1.5 font-semibold border-b border-slate-200 dark:border-zink-500"
                                        tdclassName="px-3.5 py-1.5 border-y border-slate-200 dark:border-zink-500"
                                        PaginationClassName="flex flex-col items-center gap-4 px-4 mt-3 md:flex-row"
                                    />
                                    :
                                    (<div className="noresult">
                                        <div className="py-6 text-center">
                                            <Search className="size-6 mx-auto text-sky-500 fill-sky-100 dark:sky-500/20" />
                                            <h5 className="mt-2 mb-1">Sorry! No Result Found</h5>
                                        </div>
                                    </div>)}
                            </div>)
                        }
                    </div>
                </div>
            </div>


            {/* User Modal  */}
            <Modal show={show} onHide={toggle} id="defaultModal" modal-center="true"
                className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
                dialogClassName="w-screen md:w-[40rem] bg-white shadow rounded-md dark:bg-zink-600">
                {bannerData ? <AddBanner onSave={onSave} onHide={toggle} data={bannerData} /> : <></>}
            </Modal>
        </React.Fragment>
    );
};

export default BannerList;
